export class Utils {
    static isMobile() {
        return window && window.matchMedia('(max-width: 767px)').matches;
    }
    static isTablet() {
        return window && window.matchMedia('(max-width: 1024px)').matches;
    }
    static ngbDateToDate(ngbDate: { month, day, year }) {
        if (!ngbDate) {
            return null;
        }
        return new Date(`${ngbDate.month}/${ngbDate.day}/${ngbDate.year}`);
    }
    static dateToNgbDate(date: Date) {
        if (!date) {
            return null;
        }
        date = new Date(date);
        return { month: date.getMonth() + 1, day: date.getDate(), year: date.getFullYear() };
    }
    static scrollToTop(selector: string) {
        if (document) {
            const element = <HTMLElement>document.querySelector(selector);
            element.scrollTop = 0;
        }
    }
    static genId() {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    /** Phone numbers are US only (+1); the table keeps the dial code, mask and length in one place. */
    static readonly phoneCountries = [
        { code: 'US', name: 'United States', dial: '1', mask: '(000) 000-0000', length: 10 }
    ];
    static getPhoneCountry(code: string) {
        return Utils.phoneCountries.find(c => c.code === code) || Utils.phoneCountries[0];
    }
    /**
     * Splits a phone into country + national digits. Accepts E.164 ("+250788000101"), a pasted full number
     * ("+1 (512) 555-0114") or a legacy value without a "+" ("5125550114", "15125550114"), which is read
     * as a number of fallbackCode's country.
     */
    static parsePhone(value: any, fallbackCode = 'US'): { code: string, national: string } {
        const raw = (value ?? '').toString().trim();
        const digits = raw.replace(/\D/g, '');
        if (raw.startsWith('+')) {
            const country = Utils.phoneCountries.find(c => digits.startsWith(c.dial));
            if (country) {
                return { code: country.code, national: digits.substring(country.dial.length) };
            }
            return { code: fallbackCode, national: digits };
        }
        const fallback = Utils.getPhoneCountry(fallbackCode);
        if (digits.length > fallback.length && digits.startsWith(fallback.dial)) {
            return { code: fallback.code, national: digits.substring(fallback.dial.length) };
        }
        return { code: fallback.code, national: digits };
    }
    /** E.164, e.g. toE164('US', '5125550114') -> "+15125550114"; empty when there is no number. */
    static toE164(code: string, national: any): string {
        const digits = (national ?? '').toString().replace(/\D/g, '');
        return digits ? `+${Utils.getPhoneCountry(code).dial}${digits}` : '';
    }
    /** Display format with the code, e.g. "+1 (512) 555-0114", "+250 788 000 101". Unparseable values are returned as-is. */
    static formatPhone(value: any): string {
        if (!value) { return ''; }
        const { code, national } = Utils.parsePhone(value);
        const country = Utils.getPhoneCountry(code);
        if (national.length !== country.length) {
            return value.toString();
        }
        let i = 0;
        const formatted = country.mask.replace(/0/g, () => national[i++]);
        return `+${country.dial} ${formatted}`;
    }
}
